import { StrictMode } from 'react'

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
